import script from "./SingleEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleEvent.vue?vue&type=script&setup=true&lang=js"

import "./SingleEvent.vue?vue&type=style&index=0&id=18054448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18054448"]])

export default __exports__